/* src/app/batch/pages/batch/batch.component.scss */
/*# sourceMappingURL=batch.component.css.map */
